import axios from "axios";
import {languageToJsonMap} from "@k/global/possibleLanguages";
import {EnumDictionary} from "@k/js/delme_globals";

function setI18nLanguage (lang, i18n) {
    i18n.locale.value = lang
    axios.defaults.headers.common['Accept-Language'] = lang;
    (document.querySelector('html') as HTMLElement).setAttribute('lang', lang)
    return lang
}

export function loadLanguageAsync(lang, i18n):Promise<string> {
    // If the same language
    if (i18n.locale.value === lang) {
        return Promise.resolve(setI18nLanguage(lang, i18n))
    }

    // If the language was already loaded
    if (typeof(i18n.messages[lang]) !== "undefined") {
        return Promise.resolve(setI18nLanguage(lang,i18n))
    }
    return axios({
        url:"/konfigurator_html/languageFiles/"+languageToJsonMap[lang]
    }).then(response=>{
        i18n.setLocaleMessage(lang, replaceSpecialCharsInTranslations(response.data))

        return Promise.resolve(setI18nLanguage(lang, i18n));
    })

}

export function replaceSpecialCharsInTranslations(messages) {
    const withoutNulls= {} as EnumDictionary<string, string>
    for (const key in messages) {
        if (messages[key] !== null) {
            withoutNulls[key] = messages[key].replace("{{", "[").replace("}}", "]").replace('@', '&#64;').replace(/^\{(.*)}$/, "untranslated: $1");
        } else {
            withoutNulls[key] = key;
        }
    }
    return withoutNulls;
}
